<template>
  <el-card shadow="false" :body-style="{ padding: 0 }">
    <table-view
      table-card-title="CRM Report"
      :table-model="tableModel"
      :show-page="false"
      :table-data="tableData"
    >
      <template v-slot:radio="{ tableRow }">
        <el-radio v-model="radio" :label="tableRow.row.businessId">
          &nbsp;
        </el-radio>
      </template>
    </table-view>
    <customize-button
      type="primary"
      style="margin: 0 0 20px 20px"
      @click="handleSubmit"
    >
      Submit
    </customize-button>
  </el-card>
</template>

<script>
import { getCrmDetail } from '../../api'

export default {
  name: 'crm-report',
  data() {
    const tableModel = [
      {
        width: 30,
        label: '',
        slotName: 'radio',
      },
      {
        width: 130,
        label: 'Business ID',
        prop: 'businessId',
      },
      {
        width: 170,
        label: 'Business Name',
        prop: 'primaryBusinessName',
      },
      {
        width: 220,
        label: 'Address 1',
        prop: 'address1',
      },
      {
        width: 220,
        label: 'Address 2',
        prop: 'address2',
      },
      {
        width: 130,
        label: 'City',
        prop: 'cityName',
      },
      {
        width: 130,
        label: 'State',
        prop: 'stateCode',
      },
      {
        width: 140,
        label: 'Postal Code',
        prop: 'postalCode',
      },
      {
        width: 140,
        label: 'Country',
        prop: 'countryName',
      },
      {
        width: 130,
        label: 'Country Code',
        prop: 'countryCode',
      },
      {
        width: 180,
        label: 'Phone Number',
        prop: 'phoneNumber',
      },
      {
        width: 130,
        label: 'Ticker Symbol',
        prop: 'tickerSymbol',
      },
      {
        width: 130,
        label: 'Stock Exchange',
        prop: 'stockExchange',
      },
      {
        width: 150,
        label: 'CIK Number',
        prop: 'cikNumber',
      },
      {
        width: 160,
        label: 'Latest Statement Date',
        prop: 'latestStatementDate',
      },
      {
        width: 130,
        label: 'Employees',
        prop: 'employees',
      },
      {
        width: 170,
        label: 'Employees As Of Date',
        prop: 'employeesAsOfDate',
      },
      {
        width: 130,
        label: 'Market Cap',
        prop: 'marketCap',
      },
      {
        width: 190,
        label: 'Business Name Of Match',
        prop: 'businessNameOfMatch',
      },
      {
        width: 180,
        label: 'Address 1 Of Match',
        prop: 'address1OfMatch',
      },
      {
        width: 180,
        label: 'Address 2 Of Match',
        prop: 'address2OfMatch',
      },
      {
        width: 130,
        label: 'City Of Match',
        prop: 'cityNameOfMatch',
      },
      {
        width: 160,
        label: 'Postal Code Of Match',
        prop: 'postalCodeOfMatch',
      },
      {
        width: 170,
        label: 'Country Code Of Match',
        prop: 'countryCodeOfMatch',
      },
      {
        width: 175,
        label: 'Phone Number Of Match',
        prop: 'phoneNumberOfMatch',
      },
      {
        width: 160,
        label: 'Fax Number Of Match',
        prop: 'faxNumberOfMatch',
      },
    ]
    return {
      tableModel,
      radio: '',
      tableData: [],
    }
  },
  mounted() {
    this._getCrmDetail()
  },
  methods: {
    handleSubmit() {
      if (this.radio) {
        this.$router.push({
          name: 'bureau-report-add',
          params: { customerId: this.$route.params.customerId },
          query: {
            businessId: this.radio,
          },
        })
      } else {
        this.$message.warning('Please select')
      }
    },
    async _getCrmDetail() {
      try {
        const { id } = this.$store.state.bureauReportBasicInfo
        this.tableData = await getCrmDetail(id)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped></style>
